import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import React from "react";

export default (data, key) => {
    return (<Box key={key}>
        <TextField
            InputLabelProps={{ shrink: true }}
            margin="normal"
            error={data.error ? true : false}
            helperText={data.error}
            inputProps={data.inputProps || {}}
            fullWidth
            id={`${data.name}-${key}`}
            label={data.headerName}
            value={data.value}
            name={data.name}
            onChange={data.onCallback}
        />
    </Box>)
}